import { render, staticRenderFns } from "./CakaHome.vue?vue&type=template&id=0f43cbef&scoped=true&"
import script from "./CakaHome.vue?vue&type=script&lang=js&"
export * from "./CakaHome.vue?vue&type=script&lang=js&"
import style0 from "./CakaHome.vue?vue&type=style&index=0&id=0f43cbef&prod&lang=scss&scoped=true&"
import style1 from "./CakaHome.vue?vue&type=style&index=1&id=0f43cbef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f43cbef",
  null
  
)

export default component.exports